import { FC, ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import DiscountBanner from '@/components/home/DiscountBanner';
import { useLocation, useNavigate } from 'react-router-dom';

interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const environmentLabel = import.meta.env.VITE_ENVIRONMENT
    ?? (import.meta.env.DEV ? 'development' : 'production');
  const shouldShowEnvBanner = environmentLabel !== 'production';

  const handleRegisterClick = () => {
    if (location.pathname === '/') {
      // If on homepage, we can trigger the modal via navigation state if needed, 
      // but the homepage already has its own logic.
      // However, to make it work globally, we'll navigate to home with auth state.
      navigate('/', { state: { authModal: true, authInitialMode: 'register' } });
    } else {
      navigate('/', { state: { authModal: true, authInitialMode: 'register' } });
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {shouldShowEnvBanner && (
        <div className="bg-amber-400 text-black text-center text-xs font-semibold tracking-wide uppercase py-1">
          {environmentLabel} environment
        </div>
      )}
      <DiscountBanner onRegisterClick={handleRegisterClick} />
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
